import { apiWrapper } from "@/services/api";
import store from "@/store/index";
import mfittService from "@/services/MFITT";

// 予約済みチケットの運賃照会
// 予約→購入時の確認画面で使用
export const getTicketPriceForReserved = async () => {
  let response;
  try {
    const myLimitedExpressTicket = store.getters["MFITT/myLimitedExpressTicket"];

    response = await apiWrapper(
      "GET",
      `/mfitt/limited_express_ticket_price_inquiry?boarding_date=${mfittService.convertDateFormatForApi(
        myLimitedExpressTicket.boarding_date
      )}&from_station_id=${myLimitedExpressTicket.from_station.id}&to_station_id=${myLimitedExpressTicket.to_station.id
      }&special_designation=${convertAttributeToSpecialDesignation(myLimitedExpressTicket.seats[0].seat_attribute)}`
    );

    store.commit("MFITT/setTicketPrice", response.data);
  } catch (err) {
    console.log('ERROR"" getTicketPriceForReserved():', err);
    throw err;
  }
  return response.data;
};


const convertAttributeToSpecialDesignation = (seatAttribute) => {
  // サルーンの場合はサルーン(8)、それ以外は座席指定(7)
  if (seatAttribute == "A" || seatAttribute == "B" || seatAttribute == "C") {
    return 8;
  } else {
    return 7;
  }
}